export default __webpack_public_path__ + "04185eb37b1d3d516fc6faf4dd93d63e.png";